




















import {Component, Vue} from 'vue-property-decorator';
import AxiosModelService from '@/app/shared/service/axios-modal.service';
import {AxiosResponse} from 'axios';
import UtilService from '@/app/shared/service/util.service';
import {Enum} from '@/app/shared/enum/enum';

@Component
export default class MaketingInformationAgreeModal extends Vue {
  isVisible: boolean = true;
  termHtml: any = '';

  private http = new AxiosModelService(process.env.VUE_APP_GENIE_USER_API_URL as string);
  private util = new UtilService();

  created() {
    const kindCode: Enum.ACCOUNT.CREATE.KIND_CODE = Enum.ACCOUNT.CREATE.KIND_CODE.ALL_JOIN_MARKETING;
    this.http.get('/terms',    {params: {kindCode}}).then((response: AxiosResponse<string>) => {
      this.termHtml = this.util.xssDecode(response.data);
      const termHtmlArea: HTMLDivElement = document.querySelector('#termHtml') as HTMLDivElement;
      termHtmlArea.outerHTML = this.termHtml;
    });
  }

  onMaketingAgreeYn(maketingAgreeYn: boolean) {
    this.isVisible = false;
    this.$emit('onMaketingAgreeYn', maketingAgreeYn);
    this.$emit('input', null);
  }

  onClose() {
    this.isVisible = false;
    this.$emit('input', null);
  }
}
